import { render, staticRenderFns } from "./AssessmentDetailsScreenshoot.vue?vue&type=template&id=8cba3ee6&scoped=true"
import script from "./AssessmentDetailsScreenshoot.vue?vue&type=script&lang=ts"
export * from "./AssessmentDetailsScreenshoot.vue?vue&type=script&lang=ts"
import style0 from "./AssessmentDetailsScreenshoot.vue?vue&type=style&index=0&id=8cba3ee6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cba3ee6",
  null
  
)

export default component.exports